import * as d3 from "d3";
import * as _ from "underscore";
import * as ReactDOM from "react-dom";

export const getDataViewNode = (name: string): Element => d3.select("[data-view='" + name + "']").node() as Element;

export const renderToNodes = (compByNode: { [k: string]: JSX.Element }) => {
  for (const nodeName in compByNode) {
    ReactDOM.render(compByNode[nodeName], getDataViewNode(nodeName));
  }
};

export const callAfter = (callWhat: () => void) => {
  return (afterWhat: () => void) => {
    return _.wrap(afterWhat, (f, ...args) => {
      f(...args);
      callWhat();
    });
  };
};

export const getNestedProp = (obj: any, propPath: string): any => {
  let pv = obj;
  const ref = propPath.split(".");
  for (let i = 0, len = ref.length; i < len; i++) {
    const p = ref[i];
    pv = pv[p];
    if (pv == null) {
      break;
    }
  }
  return pv;
};

export const anyPropChanged = (obj1: any, obj2: any, props: any) => {
  for (let i = 0, len = props.length; i < len; i++) {
    const prop = props[i];
    if (getNestedProp(obj1, prop) !== getNestedProp(obj2, prop)) {
      return true;
    }
  }
  return false;
};
